import type { FrameCaptureSources } from './resolveFrameCapturePlan';
import type { QuoteFrameSource } from './types';

/** Source "Escolher frame" opens on: the slide's own source when its video
 *  URL exists, else the other one when IT exists (e.g. the original source
 *  query is still loading or failed but a render is there), else Original. */
export function resolvePickerStartSource(
  initialSource: QuoteFrameSource,
  sources: FrameCaptureSources,
): QuoteFrameSource {
  if (sources[initialSource]) return initialSource;
  const other: QuoteFrameSource = initialSource === 'original' ? 'edited' : 'original';
  if (sources[other]) return other;
  return 'original';
}
